export const USER_LOGIN_SUCCESSFULL = "user/login/successfull";
export const USER_LOGIN_ERROR = "user/login/error";
export const USER_LOGIN_LOADING = "user/login/loading";

export const USER_LOGOUT_SUCESS = "user/logout/success";


export const USER_SIGNUP_SUCCESSFULL = "user/signup/successfull";
export const USER_SIGNUP_ERROR = "user/signup/error";
export const USER_SIGNUP_LOADING = "user/signup/loading";

